// /auth-end — Entra redirects the Teams sign-in popup back to this page.
// MSAL processes the response (caching the account in localStorage, which the
// main tab shares), then we tell Teams the popup is done so it closes and the
// main tab can finish signing in silently.

import React, { useEffect } from 'react';
import { app, authentication } from '@microsoft/teams-js';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './msalConfig';

const pageStyle: React.CSSProperties = {
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: '#faf7f2',
  color: '#6b6b6b',
  fontSize: 14,
};

export const AuthEnd: React.FC = () => {
  useEffect(() => {
    (async () => {
      try {
        await app.initialize();
      } catch {
        /* continue — notify calls below will throw if SDK truly unavailable */
      }
      try {
        const pca = new PublicClientApplication({
          ...msalConfig,
          auth: {
            ...msalConfig.auth,
            redirectUri: `${window.location.origin}/auth-end`,
            navigateToLoginRequestUrl: false,
          },
        });
        await pca.initialize();
        const result = await pca.handleRedirectPromise();
        if (result && result.account) {
          authentication.notifySuccess(result.account.username);
        } else {
          authentication.notifyFailure('No authentication result');
        }
      } catch (err: unknown) {
        const e = err as { errorCode?: string; message?: string };
        authentication.notifyFailure(e.errorCode || e.message || 'Sign-in failed');
      }
    })();
  }, []);

  return <div style={pageStyle}>Completing sign-in&hellip;</div>;
};
